import { Hint } from "shared/ui/hint/Hint"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface XlsxUploadErrorHintProps {
  id: string
  error?: string
}

export function XlsxUploadErrorHint({ id, error }: XlsxUploadErrorHintProps) {
  if (!error) return null

  return (
    <Hint.Root
      id={id}
      variant="danger"
      className="new-project-overlay__xlsx-hint"
    >
      <Hint.Icon name={IconName.WARNING} />
      <Hint.Content>
        <Hint.Text>{error}</Hint.Text>
      </Hint.Content>
    </Hint.Root>
  )
}
